import React from 'react';
import { Link } from 'react-router-dom';
import { Sparkles, AlertTriangle, ArrowRight, X } from 'lucide-react';
import { useBillingStatus } from '../hooks/useBillingStatus';

export const TrialBanner = () => {
  const { billing } = useBillingStatus(true);
  const [dismissed, setDismissed] = React.useState(() => {
    if (typeof window === 'undefined') return false;
    const stamp = window.sessionStorage.getItem('mdb_trial_banner_dismissed');
    return stamp === '1';
  });

  if (!billing || billing.is_subscribed || billing.is_legacy_admin) return null;
  if (!billing.is_trial_active && !billing._error) {
    // Trial expired — banner ne s'affiche pas car la paywall redirect vers /pricing déjà
    return null;
  }
  if (!billing.is_trial_active) return null;

  const days = billing.trial_days_left ?? 0;
  const isUrgent = days <= 3;

  if (dismissed && !isUrgent) return null;

  return (
    <div
      className={`px-4 py-2.5 flex items-center justify-between gap-3 border-b ${isUrgent ? 'bg-amber-500/10 border-amber-500/40 text-amber-200' : 'bg-blue-500/10 border-blue-500/30 text-blue-200'}`}
      data-testid="trial-banner"
    >
      <div className="flex items-center gap-2 text-sm flex-1 min-w-0">
        {isUrgent ? <AlertTriangle className="w-4 h-4 flex-shrink-0" /> : <Sparkles className="w-4 h-4 flex-shrink-0" />}
        <span className="truncate">
          {isUrgent
            ? <>Plus que <strong>{days} jour{days > 1 ? 's' : ''}</strong> d'essai. Active ton abonnement pour ne pas perdre tes données.</>
            : <>Essai gratuit en cours — il te reste <strong>{days} jour{days > 1 ? 's' : ''}</strong>.</>
          }
        </span>
      </div>
      <div className="flex items-center gap-2 flex-shrink-0">
        <Link
          to="/pricing"
          className={`inline-flex items-center gap-1 px-3 py-1.5 rounded-md text-xs font-bold transition-colors ${isUrgent ? 'bg-amber-500 hover:bg-amber-400 text-zinc-950' : 'bg-amber-500 hover:bg-amber-400 text-zinc-950'}`}
          data-testid="trial-banner-cta"
        >
          S'abonner — 39€/mois <ArrowRight className="w-3 h-3" />
        </Link>
        {!isUrgent && (
          <button
            onClick={() => {
              setDismissed(true);
              window.sessionStorage.setItem('mdb_trial_banner_dismissed', '1');
            }}
            className="p-1 hover:bg-white/10 rounded"
            aria-label="Fermer"
            data-testid="trial-banner-close"
          >
            <X className="w-4 h-4" />
          </button>
        )}
      </div>
    </div>
  );
};

export default TrialBanner;
